import React, { FC, PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { AppContextProvider } from 'context';
import '@frete.com/fuel-fonts/satoshi/fontface.css';
import dsTokens from '@frete.com/fuel-foundation/fretebras/theme.json';
import { ToastProvider } from 'context/ToastProvider';
import GlobalStyle from 'global.styles';
import { ThemeProvider } from 'styled-components';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

const queryClient = new QueryClient();

export const Providers: FC<PropsWithChildren<{ withToastProvider: boolean }>> = ({ children, withToastProvider }) => {
  const fallbackRender = (): JSX.Element => null;

  return (
    <AppContextProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={dsTokens}>
          <ErrorBoundary fallbackRender={fallbackRender}>
            <GlobalStyle />
            {withToastProvider ? <ToastProvider>{children}</ToastProvider> : children}
            <div id="portal-trucker-profile" />
          </ErrorBoundary>
        </ThemeProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </AppContextProvider>
  );
};
